import { Component, OnInit } from '@angular/core';
import { OfferRequest } from '../../../common/components/solar-calculation-result/model/offer-request';
import { AnalysisService } from '../../../services/analysis.service';
import { finalize } from 'rxjs';
import { offerRequestsTableConfig } from './offer-requests-table-config';
import { FillIfEmptyValuePipe } from '../../../common/pipes/fill-if-empty-value.pipe';
import { PageTitleService } from '../../../services/page-title.service';

@Component({
  selector: 'psc-offer-requests',
  templateUrl: './offer-requests.component.html',
})
export class OfferRequestsComponent implements OnInit {

  columns = offerRequestsTableConfig.columns;
  offerRequests: OfferRequest[];
  loading: boolean;
  showOfferEditDialog: boolean;
  selectedOffer: OfferRequest;

  constructor(
    private analysisService: AnalysisService,
    public fillIfEmptyValuePipe: FillIfEmptyValuePipe,
    private pageTitleService: PageTitleService,
  ) {
    /**
     * t(title.user.offer-requests)
     */
    this.pageTitleService.setTitle('title.user.offer-requests');
  }

  ngOnInit() {
    this.getOffers();
  }

  editOfferRequest(offer: OfferRequest) {
    this.showOfferEditDialog = true;
    this.selectedOffer = offer;
  }

  offerChanged() {
    this.getOffers();
  }

  private getOffers() {
    this.loading = true;
    this.analysisService.getOfferRequests().pipe(finalize(() => {
      this.loading = false;
    })).subscribe((offers) => {
      this.offerRequests = offers;
    });
  }
}
